module.exports = __webpack_public_path__ + "img/40.9.TU.8abe41ac.png";